import { HTTP } from '@/common/utils/http';

const MAILCHIMP_LOGIN_URL = 'https://login.mailchimp.com/oauth2/authorize';
const STRIPE_LOGIN_URL = 'https://connect.stripe.com/oauth/authorize';
const ZOOM_LOGIN_URL = 'https://zoom.us/oauth/authorize';

export const SubscriptionsService = {
    getSubscriptions(schoolId) {
        return HTTP.get(`/schools/${schoolId}/integrations`);
    },

    requestZoomAuthorization(schoolId) {
        window.location.href = ZOOM_LOGIN_URL + '?response_type=code' +
            '&client_id=' + process.env.ZOOM_OAUTH_CLIENT_ID +
            '&redirect_uri=' + process.env.ZOOM_REDIRECT_URI +
            '&state=' + schoolId;
    },

    disconnectZoom(schoolId) {
        return HTTP.delete(`/schools/${schoolId}/zoom`);
    },

    requestMailChimpAuthorization(schoolId) {
        window.location.href = MAILCHIMP_LOGIN_URL + '?response_type=code' +
            '&client_id=' + process.env.MAILCHIMP_OAUTH_CLIENT_ID +
            '&redirect_uri=' + process.env.MAILCHIMP_REDIRECT_URI +
            '&state=' + schoolId;
    },

    disconnectMailchimp(schoolId) {
        return HTTP.delete(`/schools/${schoolId}/mailchimp`);
    },

    requestStripeAuthorization(schoolId) {
        window.location.href = STRIPE_LOGIN_URL + '?response_type=code' +
            '&client_id=' + process.env.STRIPE_OAUTH_CLIENT_ID +
            '&redirect_uri=' + process.env.STRIPE_REDIRECT_URI +
            '&state=' + schoolId +
            '&scope=read_write';
    },

    disconnectStripe(schoolId) {
        return HTTP.get(`/schools/${schoolId}/stripe-connect/disconnect`);
    },

    setGoogleAnalyticsTrackingId(schoolId, gaTrackingId) {
        return HTTP.patch(`/schools/${schoolId}/analytics-id`, { gaTrackingId })
    },

    getGoogleAnalyticsTrackingId(schoolId) {
        return HTTP.get(`/schools/${schoolId}/analytics-id`);
    },

    disconnectGoogleAnalytics(schoolId) {
        return HTTP.delete(`/schools/${schoolId}/analytics-id`);
    },

    setBlackbaudInfo(schoolId, form) {
        return HTTP.patch(`/schools/${schoolId}/blackbaud-connect`, form)
    },

    disconnectBlackbaud(schoolId) {
        return HTTP.delete(`/schools/${schoolId}/blackbaud-connect/disconnect`);
    },
};


// WEBPACK FOOTER //
// ./src/common/services/subscriptions/SubscriptionsService.js